import { useAlert, useAppDispatch } from "@grassrootly/rn-core";
import { Authenticate } from "@grassrootly/api";
import useBaseRequest from "../../api/BaseRequest";
import { authActions } from "../../api/auth/AuthReducer";
import { useNavigation } from "@react-navigation/native";

export function useLogin() {
  const dispatch = useAppDispatch();
  const navigation = useNavigation();
  const { success } = useAlert();

  const { loading, execute: login } = useBaseRequest(Authenticate, {
    onCompleted(data, payload) {
      if (!data) return;
      dispatch(authActions.setUser(data));
      success({ message: `Welcome, ${data.name}` });
      navigation.reset({ index: 0, routes: [{ name: "main" }] });
    },
  });

  const gotToForgotPassword = () => {
    navigation.navigate("forgot-password");
  };

  return { login, loading, gotToForgotPassword };
}
